/**
 *  @class
 *  @function FreeGift
 */

if (!customElements.get('free-gift')) {
  class FreeGift extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // Server-detected corrections: gifts whose tier is no longer met (qty 0) or duplicated gifts (qty 1).
      const adjustmentsEl = this.querySelector('[data-free-gift-adjustments]');

      if (adjustmentsEl) {
        let updates = {};
        try {
          updates = JSON.parse(adjustmentsEl.textContent);
        } catch (e) {
          updates = {};
        }
        if (Object.keys(updates).length) {
          this.postUpdate(updates).finally(() => this.refreshCart());
          return;
        }
      }

      this.querySelectorAll('input[type="checkbox"][data-variant-id]').forEach((checkbox) => {
        checkbox.addEventListener('change', this.onToggle.bind(this));
      });
    }
    setLoading() {
      this.classList.add('is-loading');
      this.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
        checkbox.disabled = true;
      });
    }
    refreshCart() {
      document.dispatchEvent(new CustomEvent('cart:refresh'));
    }
    postUpdate(updates) {
      this.setLoading();
      return fetch(`${theme.routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({
          updates: updates
        })
      });
    }
    onToggle(event) {
      const checkbox = event.target;
      const tier = checkbox.closest('.free-gift--tier');

      this.setLoading();

      if (checkbox.checked) {
        const addGift = () => fetch(`${theme.routes.cart_add_url}.js`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            items: [{
              id: parseInt(checkbox.dataset.variantId, 10),
              quantity: 1,
              properties: {
                _free_gift: tier.dataset.tier
              }
            }]
          })
        });
        // Only one gift per tier: swap out any previously selected gift before adding.
        const previousKey = tier.dataset.selectedKey;
        const request = previousKey ? this.postUpdate({ [previousKey]: 0 }).then(addGift) : addGift();

        request.finally(() => this.refreshCart());
      } else {
        const lineKey = checkbox.dataset.lineKey;

        if (!lineKey) {
          this.refreshCart();
          return;
        }
        this.postUpdate({ [lineKey]: 0 }).finally(() => this.refreshCart());
      }
    }
  }

  customElements.define('free-gift', FreeGift);
}
